import moment from "moment";
import DatePicker from "vue2-datepicker";
import DistrictService from "@/service/DistrictService";
import StaffService from "@/service/StaffService";
import BankService from "@/service/BankService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Staff } from "@/model/Staff";
import { Attachment } from "@/model/Attachment";
import { StaffSkillCerts } from "@/model/StaffSkillCerts";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employment from "./S070200-Employment.vue";
import emergencyContact from "./S070200-EmergencyContact.vue";
import staffBenefit from "./S070200-EmploymentStaffBenefit.vue";
import skillCert from "./S070200-EmployeeSkillCerts.vue";
import staffDocument from "./S070200-EmployeeDocument.vue";
import employeeJobHistory from "./S070200-EmployeeJobHistory.vue";
import employeeAcademic from "./S070200-EmployeeAcademic.vue";
import employeeProfileValidationObj from "./S070200-EmployeeProfileValidation.js";
import emergencyContactValidationObj from "./S070200-EmergencyContactValidation.js";
import employmentValidationObj from "./S070200-EmploymentValidation.js";
import Settings from "../../../constants/Settings";
import userEmployee from "./UserEmployee/UserEmployee.vue";
import staffFixAlw from "./StaffFixAlw/StaffFixAlwView.vue";
import staffRoster from "./StaffRoster/StaffRosterView.vue";
var employmentValidation = new employmentValidationObj();
var employeeEmergencyValidationObj = new emergencyContactValidationObj();
var employeeProfileDataValidationObj = new employeeProfileValidationObj();
export default {
  name: "employeeProfile",
  mounted() {
    employeeProfileDataValidationObj.employeeProfileValidation();
    employeeEmergencyValidationObj.emergencyContactValidation();
    employmentValidation.staffEmploymentValidation();
    this.getCompanyList();
    this.getAllIdTypes();
    this.getBankList();
    this.getDistrictList();
    this.getAllMaritalStatus();
    this.getStaffType();
  },
  components: {
    employment,
    emergencyContact,
    employeeAcademic,
    staffBenefit,
    skillCert,
    employeeJobHistory,
    DatePicker,
    staffDocument,
    userEmployee,
    staffFixAlw,
    staffRoster
  },

  provide() {
    return {
      $validator: this.$validator
    };
  },
  data: () => ({
    dictEnum: dictEnum,
    EmployeeProfileTab: "employeeProfileTab",
    tree: [],
    staff: new Staff(),
    staffAttachment: new Attachment(),
    staffSkillCerts: new StaffSkillCerts(),
    isEditMode: false,
    isViewMode: true,
    companyList: [],
    idTypeList: [],
    countryList: [],
    locationList: [],
    districtList: [],
    areaList: [],
    bankList: [],
    maritalStatusList: [],
    validationArrayList: [],
    staffTypeList: [],
    disabledAfter: new Date(),
    IsEditButton: false,
    selectedTab: "employeeProfile",
    isResign: false,
    GenderList: [
      {
        id: "M",
        EDesc: "Male",
        CDesc: "男"
      },
      {
        id: "F",
        EDesc: "Female",
        CDesc: "女"
      }
    ],
    mode: "",
    langList: [
      { CDesc: "英文", EDesc: "English", value: "EN" },
      { CDesc: "繁體中文", EDesc: "Traditional Chinese", value: "TC" },
      { CDesc: "簡體中文", EDesc: "Simplified Chinese", value: "SC" }
    ]
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    ModClock() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModCLK
      );
      if (find) {
        return find.ParamVal.toLowerCase() === "true";
      } else {
        return true;
      }
    },
    ModLv() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find = sysParams.find(x => x.ParamCode == Settings.SysParams.ModLv);
      if (find) {
        return find.ParamVal.toLowerCase() === "true";
      } else {
        return true;
      }
    },
    ModRecu() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModRecu
      );
      if (find) {
        return find.ParamVal.toLowerCase() === "true";
      } else {
        return true;
      }
    },
    ModPay() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const find = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModPay
      );
      if (find) {
        return find.ParamVal.toLowerCase() === "true";
      } else {
        return true;
      }
    }
  },
  methods: {
    insteadTable: function(evn) {
      var expand = $(".expand");
      $(expand).toggleClass("show");
      $(expand)
        .parent()
        .parent()
        .parent()
        .next(".sub-level")
        .toggle();
    },
    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.companyList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllIdTypes() {
      const obj = {};
      const response = await StaffService.getAllIdTypes(obj);
      if (response.data.IsSuccess) {
        this.idTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDistrictList() {
      const obj = {};
      const response = await DistrictService.getDistrict(obj);
      if (response.data.IsSuccess) {
        this.locationList = response.data.Data;
        var countryList = this.locationList.filter(
          obj => obj.District == "" && obj.Area == ""
        );
        this.countryList = countryList;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    changeCountry: function() {
      var self = this;
      self.staff.District = "";
      var districtList = self.locationList.filter(
        obj =>
          obj.Country == self.staff.Country &&
          obj.Area == "" &&
          obj.District != "" &&
          obj.District != "-"
      );
      self.districtList = districtList;
    },
    changeDistrict: function() {
      var self = this;
      self.staff.Area = "";
      var areaList = self.locationList.filter(
        obj =>
          obj.District == self.staff.District &&
          obj.Area != "" &&
          obj.Area != "-"
      );
      self.areaList = areaList;
    },
    selectStaffBenefit: function() {
      var self = this;
      if (self.staff.StaffEmployment.StaffGrade != "") {
        self.$refs.refStaffBenefit.$data.IsStaffBenefitTab = true;
        self.$refs.refStaffBenefit.getAllBenefit();
      } else {
        SweetAlertService.warning(
          "Warn",
          self.t.t(self.dictEnum.MSG_SelectGrade)
        );
        self.$refs.refStaffBenefit.$data.IsStaffBenefitTab = false;
        return;
      }
    },
    async getStaffType() {
      var self = this;
      const obj = {};
      const response = await StaffService.getStaffType(obj);
      if (response.data.IsSuccess) {
        self.staffTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getBankList() {
      const obj = {};
      const response = await BankService.getAllBanks(obj);
      if (response.data.IsSuccess) {
        this.bankList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllMaritalStatus() {
      const obj = {};
      const response = await StaffService.getAllMaritalStatus(obj);
      if (response.data.IsSuccess) {
        this.maritalStatusList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async printStaff() {
      var self = this;
      const obj = {
        staffId: self.staff.StaffID
      };
      const response = await StaffService.printStaff(obj);
      if (response.data.IsSuccess) {
        window.open(response.data.Data, "_blank");
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    clearFilterValue() {
      var self = this;
      self.$refs.refStaffAcademic.$data.academicObj.selectAll = false;
      self.$refs.refEmployeeJobHistory.$data.JobHistoryObj.selectAll = false;
      self.$refs.refStaffBenefit.$data.benefitObj.selectAll = false;
      self.$refs.refEmergencyContact.$data.emergencyContactObj.selectAll = false;
    },
    resetStaffData: function() {
      var self = this;
      self.isEditMode = false;
      self.isViewMode = true;
      self.staff = new Staff();
      self.$validator.reset();
      self.vErrors.clear();
      self.$refs.refEmergencyContact.$validator.reset();
      self.$refs.refEmergencyContact.vErrors.clear();
      self.$refs.refEmployment.$validator.reset();
      self.$refs.refEmployment.vErrors.clear();
      self.$refs.refStaffBenefit.$validator.reset();
      self.$refs.refStaffBenefit.vErrors.clear();
      self.$refs.refStaffAcademic.$validator.reset();
      self.$refs.refStaffAcademic.vErrors.clear();
      self.$refs.refEmployeeJobHistory.$validator.reset();
      self.$refs.refEmployeeJobHistory.vErrors.clear();
      self.clearFilterValue();
      self.IsEditButton = false;
      self.$parent.$parent.$data.IsEditButton = false;
      self.$parent.$parent.$data.isInActiveStaff = false;
      self.$parent.$parent.$data.staffId = "";
      self.disabledStartDate();
    },
    OnStaffImageOpen: function() {
      var self = this;
      $("#staffPhoto").click();
    },
    changeComp() {
      this.staff.SupervisorID = "";
    },
    async saveStaffData(obj) {
      var self = this;
      const response = await StaffService.addStaff(obj);
      if (response.data.IsSuccess) {
        self.isResign = false;
        SweetAlertService.success("Success", response.data.Message);
        // self.resetStaffData();
        await self.editStaff();
        await self.$parent.$parent.getStaffList();
        await self.$refs.refEmployment.getStaffList();
      } else {
        self.staff.StaffEmploymentList = [];
        if (self.staff.StaffEmgConts.length > 0) {
          self.staff.StaffEmgConts.forEach(element => {
            element.EmgCont = element.EmgCont ? "true" : "false";
          });
        }
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditStaffData(obj) {
      var self = this;
      const response = await StaffService.updateStaff(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        // self.resetStaffData();
        await self.editStaff();
        await self.$parent.$parent.getStaffList();
        await self.$refs.refEmployment.getStaffList();
      } else {
        self.staff.StaffEmploymentList = [];
        if (self.staff.StaffEmgConts.length > 0) {
          self.staff.StaffEmgConts.forEach(element => {
            element.EmgCont = element.EmgCont ? "true" : "false";
          });
        }
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    cancelStaff() {
      var self = this;
      self.isEditMode = false;
      self.isViewMode = true;
    },
    findUserInTree(StaffID) {
      let user = null;
      for (let i = 0; i < this.$parent.$parent.staffTree.length; i++) {
        user = this.searchTree(this.$parent.$parent.staffTree[i], StaffID);
        if (user) {
          break;
        }
      }
      return user;
    },
    searchTree(element, matchingTitle) {
      if (element.StaffID == matchingTitle) {
        return element;
      } else if (element.children != null) {
        let i;
        let result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingTitle);
        }
        return result;
      }
      return null;
    },
    async saveStaff() {
      var self = this;
      self.mode = "edit";
      self.validationArrayList = [];
      self.validationArrayList.push(self);
      self.validationArrayList.push(self.$refs.refEmergencyContact);
      self.validationArrayList.push(self.$refs.refEmployment);
      self.validationArrayList.push(self.$refs.refStaffBenefit);
      self.validationArrayList.push(self.$refs.refEmployeeJobHistory);
      self.validationArrayList.push(self.$refs.refStaffAcademic);
      self.validationArrayList.push(self.$refs.refStaffFixAlw);
      var validationArray = self.validationArrayList.map(function(child) {
        return child.$validator.validateAll();
      });
      console.log(
        "validationArray===",
        validationArray,
        self.validationArrayList
      );

      window.Promise.all(validationArray)
        .then(v => {
          v.some(element => {
            if (element == false) {
              throw "Exists error in child component!";
            }
          });
          self.$validator.validateAll().then(result => {
            if (result && v) {
              if (self.staff.StaffEmgConts.length > 0) {
                self.staff.StaffEmgConts.forEach(element => {
                  element.StaffID = self.staff.StaffID;
                  element.EmgCont = element.EmgCont == "true" ? true : false;
                });
              }
              if (self.staff.StaffJobHistoryList.length > 0) {
                self.staff.StaffJobHistoryList.forEach(element => {
                  element.StaffID = self.staff.StaffID;
                  element.AddBy = self.$store.getters[StoreGetter.user].UserID;
                  element.ModifyBy =
                    self.$store.getters[StoreGetter.user].UserID;
                });
              }
              if (self.staff.StaffEmployHistoryList.length > 0) {
                self.staff.StaffEmployHistoryList.forEach(element => {
                  element.StaffID = self.staff.StaffID;
                  element.JobCode = self.staff.StaffEmployment.JobCode;
                  element.Salary = Number(element.Salary);
                  element.AddBy = self.$store.getters[StoreGetter.user].UserID;
                  element.ModifyBy =
                    self.$store.getters[StoreGetter.user].UserID;
                });
              }
              if (self.staff.StaffAcademicList.length > 0) {
                self.staff.StaffAcademicList.forEach(element => {
                  element.StaffID = self.staff.StaffID;
                  element.AddBy = self.$store.getters[StoreGetter.user].UserID;
                  element.ModifyBy =
                    self.$store.getters[StoreGetter.user].UserID;
                });
              }
              if (self.staff.SkillCertList.length > 0) {
                self.staff.StaffSkillCertsList = [];
                self.staff.SkillCertList.forEach(element => {
                  if (element.ItemList != null && element.ItemList.length > 0) {
                    element.ItemList.forEach(value => {
                      if (value.AnsType != "CHK") {
                        if (value.Ans != "") {
                          self.staffSkillCerts = new StaffSkillCerts();
                          self.staffSkillCerts.StaffID = self.staff.StaffID;
                          self.staffSkillCerts.SkillCate = value.SkillCate;
                          self.staffSkillCerts.Item = value.Item;
                          self.staffSkillCerts.Seq = Number(value.Seq);
                          self.staffSkillCerts.Ans = value.Ans;
                          if (value.DateFrom != null && value.DateFrom != "") {
                            self.staffSkillCerts.DateFrom = moment(
                              String(value.DateFrom)
                            ).format(Settings.DateTime.yyyymmdd);
                          } else {
                            self.staffSkillCerts.DateFrom = "1900-01-01";
                          }
                          if (value.DateTo != null && value.DateTo != "") {
                            self.staffSkillCerts.DateTo = moment(
                              String(value.DateTo)
                            ).format(Settings.DateTime.yyyymmdd);
                          } else {
                            self.staffSkillCerts.DateTo = "1900-01-01";
                          }
                          self.staffSkillCerts.AddBy =
                            self.$store.getters[StoreGetter.user].UserID;
                          self.staffSkillCerts.ModifyBy =
                            self.$store.getters[StoreGetter.user].UserID;
                          self.staff.StaffSkillCertsList.push(
                            self.staffSkillCerts
                          );
                        }
                      } else {
                        if (
                          value.OptionCheckboxModelList != null &&
                          value.OptionCheckboxModelList.length > 0
                        ) {
                          var arrayList = [];
                          value.OptionCheckboxModelList.forEach(
                            optionCheckboxDetail => {
                              if (optionCheckboxDetail.Answer) {
                                arrayList.push(optionCheckboxDetail.Question);
                              }
                            }
                          );
                          if (arrayList.length > 1) {
                            value.Ans = arrayList.join(",");
                          } else if (arrayList.length > 0) {
                            value.Ans = arrayList[0];
                          }
                          if (value.Ans != "") {
                            self.staffSkillCerts = new StaffSkillCerts();
                            self.staffSkillCerts.StaffID = self.staff.StaffID;
                            self.staffSkillCerts.SkillCate = value.SkillCate;
                            self.staffSkillCerts.Item = value.Item;
                            self.staffSkillCerts.Seq = Number(value.Seq);
                            self.staffSkillCerts.Ans = value.Ans;
                            if (
                              value.DateFrom != null &&
                              value.DateFrom != ""
                            ) {
                              self.staffSkillCerts.DateFrom = moment(
                                String(value.DateFrom)
                              ).format(Settings.DateTime.yyyymmdd);
                            } else {
                              self.staffSkillCerts.DateFrom = "1900-01-01";
                            }
                            if (value.DateTo != null && value.DateTo != "") {
                              self.staffSkillCerts.DateTo = moment(
                                String(value.DateTo)
                              ).format(Settings.DateTime.yyyymmdd);
                            } else {
                              self.staffSkillCerts.DateTo = "1900-01-01";
                            }
                            self.staffSkillCerts.AddBy =
                              self.$store.getters[StoreGetter.user].UserID;
                            self.staffSkillCerts.ModifyBy =
                              self.$store.getters[StoreGetter.user].UserID;
                            self.staff.StaffSkillCertsList.push(
                              self.staffSkillCerts
                            );
                          }
                        }
                      }
                    });
                  }
                });
              }
              if (self.staff.StaffAttachmentList.length > 0) {
                self.staff.StaffAttachmentList.forEach(element => {
                  element.DocType = "SAC";
                  element.StaffID = self.staff.StaffID;
                  element.AddBy = self.$store.getters[StoreGetter.user].UserID;
                });
              }
              if (self.staff.StaffBenefitList.length > 0) {
                self.staff.StaffBenefitList.forEach(element => {
                  element.StaffID = self.staff.StaffID;
                  element.AddBy = self.$store.getters[StoreGetter.user].UserID;
                  element.ModifyBy =
                    self.$store.getters[StoreGetter.user].UserID;
                });
              }
              if (self.staff.DOB != null && self.staff.DOB != "") {
                const dob = self.staff.DOB
                  ? moment(self.staff.DOB).format(Settings.DateTime.yyyymmdd)
                  : "1900-01-01";
              } else {
                self.staff.DOB = "1900-01-01";
              }
              if (
                self.staff.StaffEmployment.DateJoin != null &&
                self.staff.StaffEmployment.DateJoin != "" &&
                self.staff.StaffEmployment.DateJoin != undefined
              ) {
                self.staff.StaffEmployment.DateJoin = moment(
                  self.staff.StaffEmployment.DateJoin
                ).format(Settings.DateTime.yyyymmdd);
                self.staff.StaffEmployment.DateProbatEnd = moment(
                  self.staff.StaffEmployment.DateProbatEnd
                ).format(Settings.DateTime.yyyymmdd);
                if (
                  self.staff.StaffEmployment.DateTerm != null &&
                  self.staff.StaffEmployment.DateTerm != ""
                ) {
                  self.staff.StaffEmployment.DateTerm = moment(
                    self.staff.StaffEmployment.DateTerm
                  ).format(Settings.DateTime.yyyymmdd);
                } else {
                  self.staff.StaffEmployment.DateTerm = "1900-01-01";
                }
                if (
                  self.staff.StaffEmployment.DateLastWork != null &&
                  self.staff.StaffEmployment.DateLastWork != ""
                ) {
                  self.staff.StaffEmployment.DateLastWork = moment(
                    self.staff.StaffEmployment.DateLastWork
                  ).format(Settings.DateTime.yyyymmdd);
                } else {
                  self.staff.StaffEmployment.DateLastWork = "1900-01-01";
                }
                self.staff.StaffEmployment.Salary = self.staff.StaffEmployment
                  .Salary
                  ? Number(self.staff.StaffEmployment.Salary)
                  : 0;
                self.staff.StaffEmployment.StaffID = self.staff.StaffID;
                self.staff.StaffEmployment.AddBy =
                  self.$store.getters[StoreGetter.user].UserID;
                self.staff.StaffEmployment.ModifyBy =
                  self.$store.getters[StoreGetter.user].UserID;
                const DateResign = moment(
                  self.staff.StaffEmployment.DateResign
                ).format(Settings.DateTime.yyyymmdd);
                self.staff.StaffEmployment.DateResign = self.staff
                  .StaffEmployment.DateResign
                  ? DateResign
                  : "1900-01-01";

                const staff = self.findUserInTree(self.staff.StaffID);
                if (
                  staff &&
                  staff.children.length > 0 &&
                  self.staff.StaffEmployment.DateLastWork != "1900-01-01"
                ) {
                  SweetAlertService.warning(
                    "Warn",
                    this.t.t(dictEnum.MSG_ReassignSubordinates)
                  );
                  return;
                }

                self.staff.StaffFixAlwList.forEach(
                  x => x.StaffID == self.staff.StaffID
                );

                if (self.staff.StaffEmploymentList.length > 0) {
                  self.staff.StaffEmploymentList.forEach(element => {
                    element.StaffID = self.staff.StaffEmployment.StaffID;
                    element.DateJoin = self.staff.StaffEmployment.DateJoin;
                    element.DateProbatEnd =
                      self.staff.StaffEmployment.DateProbatEnd;
                    element.JobCode = self.staff.StaffEmployment.JobCode;
                    element.SACode = self.staff.StaffEmployment.SACode;
                    element.Title = self.staff.StaffEmployment.Title;
                    element.Salary = self.staff.StaffEmployment.Salary;
                    element.EmpType = self.staff.StaffEmployment.EmpType;
                    element.StaffGrade = self.staff.StaffEmployment.StaffGrade;
                    element.EmpStatus = self.staff.StaffEmployment.EmpStatus;
                    element.Dept = self.staff.StaffEmployment.Dept;
                    element.TeamCode = self.staff.StaffEmployment.TeamCode;
                    element.CalMethod= self.staff.StaffEmployment.CalMethod;
                    element.Supervisor = self.staff.SupervisorID;
                    element.DateTerm = self.staff.StaffEmployment.DateTerm;
                    element.DateLastWork =
                      self.staff.StaffEmployment.DateLastWork;
                    element.AddBy =
                      self.$store.getters[StoreGetter.user].UserID;
                    element.ModifyBy =
                      self.$store.getters[StoreGetter.user].UserID;
                  });
                } else {
                  self.staff.StaffEmploymentList.push(
                    self.staff.StaffEmployment
                  );
                }
              }
console.log(self.staff.StaffEmploymentList,'修改的员工的雇佣信息');
              const obj = {
                model: {
                  StaffID: self.staff.StaffID,
                  StaffType: self.staff.StaffType,
                  CompCode: self.staff.CompCode,
                  EngName: self.staff.EngName,
                  EngLastName: self.staff.EngLastName,
                  ChiName: self.staff.ChiName,
                  ChiLastName: self.staff.ChiLastName,
                  BadgeNum: self.staff.BadgeNum,
                  EmpRef: self.staff.EmpRef,
                  Lang: self.staff.Lang,
                  DocTypeCode: self.staff.DocTypeCode,
                  DocNum: self.staff.DocNum,
                  Country: self.staff.Country,
                  POB: self.staff.POB,
                  District: self.staff.District,
                  Area: self.staff.Area,
                  Addr: self.staff.Addr,
                  Email: self.staff.Email,
                  Gender: self.staff.Gender,
                  Mobile: self.staff.Mobile,
                  BankAcNum: self.staff.BankAcNum,
                  AcHolderName: self.staff.AcHolderName,
                  BankCode: self.staff.BankCode,
                  DOB: moment(self.staff.DOB).format(
                    Settings.DateTime.yyyymmdd
                  ),
                  MaritalStatus: self.staff.MaritalStatus,
                  SupervisorID: self.staff.SupervisorID,
                  Photo: self.staff.Photo,
                  PhotoURL: self.staff.PhotoURL,
                  PhotoFile: self.staff.PhotoFile,
                  StaffAttachmentList: self.staff.StaffAttachmentList,
                  StaffSkillCertsList: self.staff.StaffSkillCertsList,
                  StaffEmgConts: self.staff.StaffEmgConts,
                  StaffEmploymentList: self.staff.StaffEmploymentList,
                  StaffBenefitList: self.staff.StaffBenefitList,
                  StaffEmployHistoryList: self.staff.StaffEmployHistoryList,
                  StaffJobHistoryList: self.staff.StaffJobHistoryList,
                  StaffAcademicList: self.staff.StaffAcademicList,
                  StaffFixAlwList: self.staff.StaffFixAlwList,
                  ModifyBy: self.$store.getters[StoreGetter.user].UserID,
                  AddBy: self.$store.getters[StoreGetter.user].UserID,
                  DateResign: self.staff.DateResign,
                  UserGrpsList: self.staff.UserGrpsList
                }
              };
              if (self.isEditMode) {
                self.EditStaffData(obj);
              } else {
                self.saveStaffData(obj);
              }
            }
          });
        })
        .catch(() => {
          SweetAlertService.warning(
            "Warn",
            self.t.t(dictEnum.MSG_ValidationFailed)
          );
        });
    },
    closeStaffPopup: function() {
      var self = this;
      $("#deleteStaffodel").modal("hide");
    },
    deleteStaffPopup: function() {
      var self = this;
      if (self.isEditMode) {
        $("#deleteStaffodel").modal("show");
      } else {
        SweetAlertService.warning(
          "Warn",
          self.t.t(dictEnum.MSG_SelectDeleteRecord)
        );
      }
    },
    async deleteStaff() {
      $("#deleteStaffodel").modal("hide");
      var self = this;
      const obj = {
        staffId: self.staff.StaffID,
        userId: self.$store.getters[StoreGetter.user].UserID
      };
      const response = await StaffService.deleteStaff(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffData();
        await self.$parent.$parent.getStaffList();
        await self.$refs.refEmployment.getStaffList();
      } else {
        self.staff.StaffEmploymentList = [];
        if (self.staff.StaffEmgConts.length > 0) {
          self.staff.StaffEmgConts.forEach(element => {
            element.EmgCont = element.EmgCont ? "true" : "false";
          });
        }
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAttachmentOpen: function() {
      var self = this;
      $("#attachmentFile").click();
    },
    onFileChange(e, fieldName, fileList) {
      var self = this;
      if (!fileList.length) return;
      var counter = -1,
        file;
      while ((file = e.target.files[++counter])) {
        const reader = new FileReader();
        reader.onload = (function(file) {
          return function(e1) {
            var path = reader.result ? reader.result.toString() : "";
            self.staffAttachment = new Attachment();
            self.staffAttachment.DocURL = path;
            self.staffAttachment.DocFile =
              path.indexOf(",") != -1 ? path.split(",").pop() : "";
            self.staffAttachment.DocMime = file.type;
            self.staffAttachment.IsImageFile =
              path.indexOf("image") != -1 ? true : false;
            self.staff.StaffAttachmentList.push(self.staffAttachment);
          };
        })(file);
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    },
    onPhotoChange(payload) {
      var self = this;
      var file = payload; // in case vuetify file input
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function() {
          var image = new Image();
          image.src = reader.result ? reader.result.toString() : "";
          image.onload = function() {
            var path = reader.result ? reader.result.toString() : "";
            self.staff.PhotoURL =
              path.indexOf(",") != -1 ? path.split(",").pop() : "";
            self.staff.Photo =
              path.indexOf(",") != -1 ? path.split(",").pop() : "";
          };
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    disabledStartDate: function() {
      var self = this;
      if (
        self.staff.StaffType == "S" &&
        (self.isEditMode || self.isViewMode) &&
        self.staff.StaffEmployment.DateJoin != "" &&
        self.staff.StaffEmployment.DateJoin != null
      ) {
        self.$refs.refEmployment.$data.isDisabledStartDate = true;
      } else if (
        self.staff.StaffType == "C" &&
        (self.isEditMode || self.isViewMode) &&
        self.staff.StaffEmployment.DateJoin != "" &&
        self.staff.StaffEmployment.DateJoin != null
      ) {
        self.$refs.refEmployment.$data.isDisabledStartDate = true;
      } else if (self.isViewMode) {
        self.$refs.refEmployment.$data.isDisabledStartDate = true;
      } else {
        self.$refs.refEmployment.$data.isDisabledStartDate = false;
      }
    },
    editStaff() {
      var self = this;
      self.mode = "edit";
      self.isEditMode = true;
      self.isViewMode = false;
      self.disabledStartDate();
    },
    initStaff() {
      var self = this;
      self.staff = new Staff();

      // default Staff Data
      if (self.companyList.length > 0) {
        self.staff.CompCode = self.companyList[0].CompCode;
      }

      self.$parent.$parent.$data.IsEditButton = false;
      self.mode = "new";
      self.IsEditButton = false;
      self.isEditMode = false;
      self.isViewMode = false;
      self.isResign = false;
      self.$validator.reset();
      self.vErrors.clear();
      self.$refs.refEmergencyContact.$validator.reset();
      self.$refs.refEmergencyContact.vErrors.clear();
      self.$refs.refEmployment.$validator.reset();
      self.$refs.refEmployment.vErrors.clear();
      self.$refs.refStaffBenefit.$validator.reset();
      self.$refs.refStaffBenefit.vErrors.clear();
      self.$refs.refEmployeeJobHistory.$validator.reset();
      self.$refs.refEmployeeJobHistory.vErrors.clear();
      self.clearFilterValue();
      self.$refs.refSkillCert.getAllSkillCertList();
      self.disabledStartDate();
      self.EmployeeProfileTab = 0;
      self.changeTab("employeeProfile");
    },
    changeTab: function(tab) {
      var self = this;
      switch (tab) {
        case "employeeBenefit":
          self.selectStaffBenefit();
          break;
      }
      self.selectedTab = tab;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeProfile.js